import { render, staticRenderFns } from "./PrecosList.vue?vue&type=template&id=149ca496"
import script from "./PrecosList.vue?vue&type=script&lang=js"
export * from "./PrecosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports